import { onMounted, onUnmounted } from 'vue';

export function usePopstateHandler(callback) {

  onMounted(() => {
    const handlePopstate = async () => {
      console.log('Back button clicked');
      if (typeof callback === 'function') {
        await callback();
      }
    };

    window.addEventListener('popstate', handlePopstate);

    onUnmounted(() => {
      
      try {
        console.log('--------------', 'removed pop state');
        window.removeEventListener('popstate', handlePopstate);
      } catch (error) {
        console.error('Error occurred while removing popstate listener:', error);
      }

      
    });
  });
}
